
export const environment = {
  runningAsWebComponent: true,
  contactInfoLink: 'https://education.ohio.gov/Miscellaneous/Contact-Verification',
  armApiEndpoint: 'https://edu-dev-arm-admin.azurewebsites.net',
  mdmApiEndpoint: 'https://edu-dev-eas-mdm-api.azurewebsites.net',
  debug: false
};
